<template>
	<div class="bg-site min-w-screen min-h-screen siteContainer">
		<FullPageLoader />
		<TopNav />
		<div class="sm:container max-sm:mx-4 mx-auto pt-20 pb-20 min-h-screen md:max-w-screen-lg sm:px-4">
			<slot />
		</div>
	</div>
</template>

<script setup></script>

<style scoped></style>
